import { Container, Typography } from '@mui/material'
import React from 'react'
import styles from './trackingLastUpdateStyles'

const TrackingLastUpdate = ({guide}) => {
  return (
    <Container style={styles.mainContainer}>
      <Typography variant="h6" sx={styles.title}>Última actualización</Typography>
      <Container sx={styles.secondaryContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="h6" sx={styles.data}>{guide?.guide_info?.date ?? 'Desconocido'}</Typography>
        </Container>
        <Container sx={styles.sectionDateContainer}>
          <Typography variant="h6" sx={styles.date}>{guide?.guide_info?.time ?? 'Desconocido'}{guide?.guide_info?.time_type ?? ''}</Typography>
        </Container>
      </Container>
    </Container>
  )
}

export default TrackingLastUpdate